(function () {
  if (window.ptBase) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  var cache = {};

  var revealIO = hasIO && !reduce
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            revealIO.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' })
    : null;

  var imgIO = hasIO
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            imgIO.unobserve(e.target);
            prepare(e.target);
          }
        });
      }, { rootMargin: '600px 0px' })
    : null;

  function scan(root) {
    root = root || document;
    root.querySelectorAll('[data-pt-rv]:not(.is-in)').forEach(function (el) {
      if (revealIO) revealIO.observe(el);
      else el.classList.add('is-in');
    });
    root.querySelectorAll('img[data-pt-cutout]:not([data-pt-done])').forEach(function (img) {
      if (imgIO) imgIO.observe(img);
      else prepare(img);
    });
  }

  function prepare(img) {
    if (img.dataset.ptDone) return;
    img.dataset.ptDone = '1';
    var wrap = img.closest('.pt-cutout-wrap') || img.parentElement;
    var mode = img.dataset.cutout || 'auto';
    var show = function () { img.classList.add('is-ready'); };
    var blend = function () { if (wrap) wrap.classList.add('is-blend'); show(); };
    if (mode === 'off') { show(); return; }
    if (mode === 'blend') { blend(); return; }
    var started = false;
    var run = function () {
      if (started) return;
      started = true;
      var tol = parseFloat(img.dataset.tolerance) || 26;
      var key = (img.currentSrc || img.src) + '|' + tol;
      if (!cache[key]) cache[key] = cutout(img, tol);
      cache[key].then(function (res) {
        if (!res) { blend(); return; }
        img.addEventListener('load', show, { once: true });
        img.removeAttribute('srcset');
        img.setAttribute('width', res.w);
        img.setAttribute('height', res.h);
        img.src = res.url;
      });
    };
    if (img.complete && img.naturalWidth) {
      run();
    } else if (img.complete) {
      blend();
    } else {
      img.addEventListener('load', run, { once: true });
      img.addEventListener('error', function () {
        if (started) return;
        img.removeAttribute('crossorigin');
        img.addEventListener('load', blend, { once: true });
        img.src = img.getAttribute('src');
      }, { once: true });
    }
  }

  function cutout(img, tolSetting) {
    return new Promise(function (resolve) {
      try {
        var tol = tolSetting * 2;
        var soft = tol * 1.6;
        var w = img.naturalWidth;
        var h = img.naturalHeight;
        var canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        var ctx = canvas.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(img, 0, 0);
        var imageData = ctx.getImageData(0, 0, w, h);
        var d = imageData.data;
        var r = 0, g = 0, b = 0, n = 0, x, y, i, p;
        function add(px, py) { var k = (py * w + px) * 4; r += d[k]; g += d[k + 1]; b += d[k + 2]; n++; }
        for (x = 0; x < w; x += 4) { add(x, 0); add(x, h - 1); }
        for (y = 0; y < h; y += 4) { add(0, y); add(w - 1, y); }
        r /= n; g /= n; b /= n;
        function dist(k) { var dr = d[k] - r, dg = d[k + 1] - g, db = d[k + 2] - b; return Math.sqrt(dr * dr + dg * dg + db * db); }
        var bg = new Uint8Array(w * h);
        var stack = new Int32Array(w * h);
        var sp = 0, removed = 0;
        function push(q) { if (!bg[q] && dist(q * 4) <= tol) { bg[q] = 1; stack[sp++] = q; removed++; } }
        for (x = 0; x < w; x++) { push(x); push((h - 1) * w + x); }
        for (y = 0; y < h; y++) { push(y * w); push(y * w + w - 1); }
        while (sp) {
          p = stack[--sp];
          x = p % w;
          y = (p - x) / w;
          if (x > 0) push(p - 1);
          if (x < w - 1) push(p + 1);
          if (y > 0) push(p - w);
          if (y < h - 1) push(p + w);
        }
        var ratio = removed / (w * h);
        if (ratio < 0.06 || ratio > 0.92) { resolve(false); return; }
        var minX = w, minY = h, maxX = 0, maxY = 0;
        for (y = 0; y < h; y++) {
          for (x = 0; x < w; x++) {
            p = y * w + x;
            i = p * 4;
            if (bg[p]) { d[i + 3] = 0; continue; }
            var nearBg = (x > 0 && bg[p - 1]) || (x < w - 1 && bg[p + 1]) || (y > 0 && bg[p - w]) || (y < h - 1 && bg[p + w]);
            if (nearBg) {
              var dd = dist(i);
              if (dd < soft) d[i + 3] = Math.max(0, Math.min(255, (255 * (dd - tol)) / (soft - tol)));
            }
            if (d[i + 3] > 24) {
              if (x < minX) minX = x;
              if (x > maxX) maxX = x;
              if (y < minY) minY = y;
              if (y > maxY) maxY = y;
            }
          }
        }
        if (maxX <= minX || maxY <= minY) { resolve(false); return; }
        ctx.putImageData(imageData, 0, 0);
        var pad = Math.round(Math.max(w, h) * 0.02);
        minX = Math.max(0, minX - pad);
        minY = Math.max(0, minY - pad);
        maxX = Math.min(w - 1, maxX + pad);
        maxY = Math.min(h - 1, maxY + pad);
        var ow = maxX - minX + 1;
        var oh = maxY - minY + 1;
        var out = document.createElement('canvas');
        out.width = ow;
        out.height = oh;
        out.getContext('2d').drawImage(canvas, minX, minY, ow, oh, 0, 0, ow, oh);
        out.toBlob(function (blob) {
          if (!blob) { resolve(false); return; }
          resolve({ url: URL.createObjectURL(blob), w: ow, h: oh });
        }, 'image/png');
      } catch (err) {
        resolve(false);
      }
    });
  }

  window.ptBase = { scan: scan, reduce: reduce };
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
